import { type CheckoutV2Configuration } from "@jti/commerce";
import type { FeatureFlags } from "@jti/fe-common";
import type { Translate } from "@jti/ui";

import type { CheckboxFieldConfig, FormFieldFactory } from "@checkout-v2/formFields";

export type ShouldUseProfileDataFieldConfigArgs = {
  checkoutConfig: CheckoutV2Configuration;
  featureFlags: FeatureFlags;
  __: Translate;
};

type ShouldUseProfileDataExtraFields = {
  toggleYesLabel: string;
  toggleNoLabel: string;
};

export type ShouldUseProfileDataFieldConfig = CheckboxFieldConfig<
  "shouldUseProfileData",
  ShouldUseProfileDataExtraFields
>;

export type ShouldUseProfileDataFieldDefaultValue = boolean;

export const shouldUseProfileDataFieldFactory: FormFieldFactory<
  "shouldUseProfileData",
  ShouldUseProfileDataFieldDefaultValue,
  [ShouldUseProfileDataFieldConfigArgs],
  [],
  ShouldUseProfileDataFieldConfig
> = {
  getDerivedConfig: ({ __, checkoutConfig, featureFlags }) => {
    return {
      name: "shouldUseProfileData",
      isHidden: !!checkoutConfig?.contact?.differentRecipientDisabled,
      label: featureFlags.ffCheckoutV2EnableIteration2
        ? __("cart.checkout.shipping_contact.ordering_for_someone_else")
        : __("cart.checkout.shipping_contact.use_account"),
      toggleYesLabel: __("cart.checkout.shipping_contact.toggle.yes"),
      toggleNoLabel: __("cart.checkout.shipping_contact.toggle.no"),
    };
  },

  getDefaultValue: () => {
    return true;
  },
};
